import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Spinner from '../Spinner';

const Base = ({ children, onClick, disabled, loading, hover, className, url, ...rest }) => {
    const btnProps = {...rest};
    if (!(disabled || loading)) {
        btnProps.onClick = onClick;
        if (url) {
            btnProps.href = url;
        }
    }
    const label = loading ? <Spinner.Dots /> : children;
    return (

        url ? (
            <a
                {...btnProps} target="_blank"
                rel="noopener noreferrer"
                className={classnames('btn', className, { 'btn--force-hover': hover, 'btn--disabled': disabled })}
            >
                {label}
            </a>
        )
            : (
                <button
                    type="button" className={classnames('btn', className, { 'btn--force-hover': hover, 'btn--disabled': disabled })} disabled={disabled}
                    {...btnProps}
                >
                    {label}
                </button>
            )
    );
};

Base.propTypes = {
    onClick: PropTypes.func,
    url: PropTypes.string,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    hover: PropTypes.bool
};
Base.defaultProps = {
    onClick: () => null,
    disabled: false,
    loading: false,
    hover: false,
    url: null
};

export default React.memo(Base);
